// extracted by mini-css-extract-plugin
export var arrowsSvg = "products-module--arrowsSvg--73377";
export var headlineGrid = "products-module--headlineGrid--bfd21";
export var productContainer = "products-module--productContainer--9c3d5";
export var products = "products-module--products--4c170";
export var styledHeadline = "products-module--styledHeadline--c00aa";
export var wrapper = "products-module--wrapper--d3402";